<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="flex items-start justify-start">
      <div class="flex">
        <ToastAlert 
          :is-active="toastAlert"
          :type="typeMsg" 
          :message="msg"  
        />
      </div>
  
      <div class="w-full p-4">
        
  
        <div class="flex flex-col sm:flex-row mt-4 sm:mt-10">
  
            <div class=" w-full sm:w-1/2 mb-5">
                <div class=" w-full  sm:w-1/2 mb-10">
                    <div class="flex justify-center items-center text-2xl font-bold">
                        Redes sociales de asesor
                    </div>
                    <!-- Contenido del primer div -->
                    <div 
                        v-for="(item, index) in networks_broker"
                        :key="item.id"
                        class="flex mt-5"
                    >
                        <div class="w-[20%] sm:w-[15%] p-2 flex justify-center items-center">
                        <div v-html="item.icon" />
                        </div>

                        <div class="w-[80%] sm:w-[75%] p-2">
                        <fwb-input
                            v-model="networks_broker[index].link_broker"
                            placeholder="ej. Tuin "
                            size="sm"
                            class="w-full"                
                        />
                        </div>
                    </div>

                    <div class=" flex mt-5 justify-center items-center">
                        <fwb-button 
                        class="bg-tuin-100 hover:bg-tuin-100"
                        size="xl"
                        @click="saveNetworksBroker()"
                        >
                        Guardar redes de asesor
                        </fwb-button>
                    </div>
                </div>         
            </div>
            <div>
                <div 
                id="upload-container" 
                ref="uploadContainer"
                class="w-[339px] h-[85px] rounded-2xl border-2 border-dashed border-[#ff4265] flex items-center justify-center"
                >
                <input 
                    type="file" 
                    id="file-input" 
                    multiple 
                    class="absolute w-full h-full opacity-0 cursor-pointer"
                    @change="handleFileUpload"
                />
                <div class="text-center">
                    <div class="w-[49px] h-[49px] mx-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 42 36" fill="none">
                        <path d="M28.9317 21.8692C28.7816 22.0409..." fill="#FF4265" />
                    </svg>
                    </div>
                    <div class="text-neutral-500 text-base font-light font-['Poppins'] leading-normal">
                    Arrastra aquí tus archivos
                    </div>
                </div>
                </div>

                <div 
                id="files-list" 
                ref="filesList"
                class="hidden mt-4"
                >
                <h3 class="text-lg font-bold mb-2">Archivos cargados:</h3>
                <ul 
                    id="file-names" 
                    ref="fileNamesContainer"
                    class="list-disc pl-6 text-neutral-700"
                ></ul>
                <button 
                    @click="resetFileUpload" 
                    class="mt-2 px-4 py-2 bg-red-500 text-white rounded"
                >
                    Cancelar
                </button>
                </div>
            </div>
        </div>
      </div>
    </div>
  </template>
      
  <script setup>
  import { computed, ref, onMounted } from "vue";
  import ToastAlert from "@/commond/ToastAlert.vue";
  // LLamar a la sesion
  import { useStore } from "vuex";
  import axios from "axios";
  import { FwbInput, FwbButton } from "flowbite-vue";
  import { useRoute } from "vue-router";

  
  let networks_broker = ref([]);
  let networks_company = ref([]);
  const route = useRoute();
  const advisorId = computed(() => route.params.id);  // Obtener el ID del rol desde la URL
  let toastAlert  = ref(false);
  let typeMsg     = ref("");
  let msg         = ref("");
 
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  const files = ref([]);
  const fileNamesContainer = ref(null);
  const filesList = ref(null);
  const uploadContainer = ref(null);
  //let facebook = ref('');
  const handleFileUpload = (event) => {
    // Check if files were selected
    if (!event.target.files || event.target.files.length === 0) {
        console.error("No files selected");
        return;
    }

    // Convert FileList to array and store in reactive ref
    files.value = Array.from(event.target.files);

    // Clear previous file list
    if (fileNamesContainer.value) {
        fileNamesContainer.value.innerHTML = '';

        // Add file names to the list
        files.value.forEach((file) => {
        const listItem = document.createElement("li");
        listItem.textContent = file.name;
        fileNamesContainer.value.appendChild(listItem);
        });

        // Show files list and hide upload container
        if (filesList.value && uploadContainer.value) {
        filesList.value.classList.remove("hidden");
        uploadContainer.value.classList.add("hidden");
        }
    }
    };

    // Optional: Function to reset file upload
    const resetFileUpload = () => {
    if (filesList.value && uploadContainer.value) {
        filesList.value.classList.add("hidden");
        uploadContainer.value.classList.remove("hidden");
    }
    files.value = [];
    };
  onMounted(async () => {
    try {
      getNetworks();  
      
    } catch (error) {
      console.error("Error al intentar traer los datos", error);
    }
  });

  async function getNetworks() {
    try {
      let options = {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      };
  
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/broker/profile/networks/${advisorId.value}`,
        options
      );
  
      if (response.status == 401) {
        store.dispatch("clearUserSession");
      }
  
      if (response.status == 200) {
        networks_broker.value   = response.data.data;
        networks_company.value  = response.data.data;
        // filteredProperties.value = response.data.resp;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  
  async function saveNetworksBroker(){

    try {
    let options = {
            headers: {
                'Authorization': `Bearer ${session.value.token_api}`
            }
    }

    let params_item = [];

    this.networks_broker.forEach(item => {
        let row = {};
        row['id']=item.id;
        row['link_broker']=item.link_broker;
        row['user_id'] = advisorId.value;
        row['company_id'] = session.value.company_id;
        
        params_item.push(row);
    });

    
    let params = {
        "type": "broker",
        "step": 3, 
        "networks": params_item
    }

    const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${advisorId.value}/update-networks`,
        params,
        options        
    );

    if (response.status == 200) {
        
        console.log('debe cambiar ')
        store.dispatch('updateStep', 3);
        
        showToast('success', 'Redes sociales guardadas correctamente');
    }

    } catch (error) {
        console.error("Error fetching data:", error);
        showToast('danger', 'No se pudo guardar las redes sociales en este momento');
    }  
  }
  
  async function showToast( type = null, message = null){
    toastAlert.value  = true;
    typeMsg.value     = type;
    msg.value         = message;
  
    setTimeout(() => {
      closeToast();
    }, 3000);
  }
  
  async function closeToast() {
    toastAlert.value = false;
    typeMsg.value = "";
    msg.value = "";
  }
  
  </script>